class Common {
  async _init() {
    return true
  }

  async setTvWindowSize() {
    return true
  }
}

export default Common
